export const NEWEST = 'newest'
export const OLDEST = 'oldest'
export const NEWEST_BY_COLLABORATOR = 'newestByCollaborator'
export const OLDEST_BY_COLLABORATOR = 'oldestByCollaborator'
export const LONGEST_UNANSWERED = 'longestUnanswered'
// we don't need/show this but it's catered for anyway
export const SHORTEST_UNANSWERED = 'shortestUnanswered'
export const DEFAULT_SORT_ORDER = NEWEST
